var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.784 10.755c-1.737 0-3.147 1.409-3.147 3.147s1.41 3.148 3.147 3.148c1.739 0 3.147-1.409 3.147-3.148s-1.409-3.147-3.147-3.147zM16.784 16c-1.156 0-2.098-0.941-2.098-2.099s0.941-2.098 2.098-2.098c1.158 0 2.098 0.941 2.098 2.098s-0.941 2.099-2.098 2.099z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.196 6.034v15.735h25.176v-15.735h-25.176zM28.324 9.583v11.137h-23.078v-13.637h23.078v2.5z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.746 22.819h-20.599v-14.686h-1.049v15.735h25.177v-1.049h-1.049z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.648 24.917h-20.599v-14.686h-1.049v15.735h25.177v-1.049h-1.049z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.819 8.165h3.147v1.049h-3.147v-1.049z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.819 18.623h3.147v1.049h-3.147v-1.049z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.603 8.165h3.147v1.049h-3.147v-1.049z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.603 18.623h3.147v1.049h-3.147v-1.049z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.d1ae837c78220fc84f735205c3334554.svg";
export { ForwardRef as ReactComponent };